import { TYPES_ITEMS } from "../api/constant";

export const getTypeMeasure = (type) => {
  const filter = TYPES_ITEMS.filter((t) => t.type === type);
  return filter.length > 0 ? filter[0].name : null;
};

export const formatNumberCOP = (number) =>
  Intl.NumberFormat("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
